<div class="modal inmodal fade in create-modal show">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div cdkScrollable class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Email Incident Report</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">From:</div>
                        <div class="col-sm-10">{{sender}}</div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">To:</div>
                        <div class="col-sm-10">
                            <ul class="to" *ngIf="receivers.length > 0">
                                <li *ngFor="let receiver of receivers; let index = index;">
                                    {{receiver.email}} <i class="fa fa-times-circle m-t-7" aria-hidden="true" (click)="removeEmail(index)"></i>
                                </li>
                            </ul>
                            <input name="recipient"
                                   id="recipientSearch"
                                   class="form-control"
                                   [(ngModel)]="recipientSearch"
                                   matInput
                                   required
                                   [matAutocomplete]="emailList">
                            <mat-autocomplete #emailList="matAutocomplete">
                                <mat-option *ngFor="let user of users | filterByPropertyPipe: recipientSearch: 'email'"
                                            (onSelectionChange)="changeAutocompleteValue(user)" [value]="user.fullName">
                                    {{ user.fullName + ' (' + user.email + ' )' }}
                                </mat-option>
                            </mat-autocomplete>
                            <spinner [spinnerShow]="showUsersSpinner"></spinner>
                        </div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Subject:</div>
                        <div class="col-sm-10">
                            <input type="text" class="form-control" name="subject" [(ngModel)]="subject" required>
                        </div>
                    </div>
                    <div class="form-group" id="summernote">{{message}}</div>

                    <div *ngIf="attachments.length">
                        <div class="row m-b-sm">
                            <div class="col-sm-2 bold">Attachments:</div>
                        </div>
                        <ul class="attachment-box m-b-lg">
                            <li *ngFor="let item of attachments; let i = index;">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                        name="attachment"
                                        id="{{ 'attachment-btn'+i }}"
                                        [ngModel]="item.checked"
                                        (change)="onChangeAttachment($event, item)">
                                    <label for="{{ 'attachment-btn'+i }}"><svg-checked></svg-checked></label>
                                </label>
                                <a (click)="incidentReportsService.showAttachment(item)">
                                    <div>
                                        <span class="file-name">{{item.name}}</span>
                                        <span class="file-size">({{+(item.fileSize/1000).toFixed(0)}}kb)</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="row text-center m-t-md">
                        <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Send</button>
                    </div>
                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <spinner [spinnerShow]="es.isUploadImageSpinnerShow"></spinner>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/send-incident-report-modal/send-incident-report-modal.component.html